import React from 'react';

const PaymentAddPage = () => {
  return <div></div>;
};

export default PaymentAddPage;
